import React from 'react'
import './App.css'
import { AuthPage } from './pages/AuthPage'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { PlayersPage } from './pages/PlayersPage'
import { store } from './app/store'
import { Provider } from 'react-redux'
import { PlayersListPage } from './pages/PlayersListPage'
import { TournamentPage } from './pages/TournamentsPageN'
import { TournamentsListPage } from './pages/TournamentsListPageN'
import { NewsPage } from './pages/NewsPage'
import { NewsListPage } from './pages/NewsListPage'
import { FileStorePage } from './pages/DocsPage'
import { FileStoreListPage } from './pages/DocsListPage'
import { TestPage } from './pages/tests/TestPage'
import { OperatoresPage } from './pages/OperatoresPage'
import { OperatoresListPage } from './pages/OperatoresListPage'
import { SettingsPage } from './pages/SettingsPage'
import { MainLoyout } from 'app/layouts/main-loyout/main-loyout'
import img from "icons/kort.jpg"

const router = createBrowserRouter([
  {
    element: <MainLoyout />,
    children: [
      {
        path: '/documents',
        element: <FileStoreListPage />
      },
      {
        path: '/documents/create',
        element: <FileStorePage />
      },
      {
        path: '/news',
        element: <NewsListPage />
      },
      {
        path: '/news/create',
        element: <NewsPage />
      },
      {
        path: '/players/create',
        element: <PlayersPage />
      },
      {
        path: '/players',
        element: <PlayersListPage />
      },
      {
        path: '/operatores/create',
        element: <OperatoresPage />
      },
      {
        path: '/operatores',
        element: <OperatoresListPage />
      },
      {
        path: '/tournaments/create',
        element: <TournamentPage />
      },
      {
        path: '/tournaments',
        element: <TournamentsListPage />
      },
      {
        path: '/settings',
        element: <SettingsPage />
      }
    ]
  },
  {
    path: '/',
    element: <AuthPage />
  },
  {
    path: '/test',
    element: <TestPage />
  },
  
])

function App () {
  return (
    <Provider store={store}>
      <RouterProvider router={router}/>
      <div className={'backgroundImage'}>
        <img src={img} alt={''}/>
        <div className={'backgroundGradient'}/>
      </div>
    </Provider>
  )
}

export default App
